import { z } from 'zod'

// Esquema para formulario de contacto
export const contactFormSchema = z.object({
  nombre: z
    .string()
    .min(2, 'El nombre debe tener al menos 2 caracteres')
    .max(50, 'El nombre no puede exceder los 50 caracteres'),
  email: z
    .string()
    .email('Ingrese un email válido')
    .min(1, 'El email es requerido'),
  mensaje: z
    .string()
    .min(10, 'El mensaje debe tener al menos 10 caracteres')
    .max(500, 'El mensaje no puede exceder los 500 caracteres')
})

// Esquema para consulta rápida (solo nombre y email)
export const quickContactSchema = z.object({
  nombre: z
    .string()
    .min(2, 'El nombre debe tener al menos 2 caracteres'),
  email: z
    .string()
    .email('Ingrese un email válido')
    .min(1, 'El email es requerido')
})
